import { useEffect, useMemo } from "react"
import { getFilters } from "../../api/filters"
import { EMPLOYMENTS, EXPERIENCES, IFilters } from "../../utils"
import { useQuery, useQueryClient, UseQueryResult } from "@tanstack/react-query"


export const useGetFilters = () => {
  const queryClient = useQueryClient()

  const {data: filters, isError, ...args} = useQuery(
    {
      queryKey: ['filters'],
      queryFn: async () => {
        return await getFilters()
      }
    }
  )

  useEffect(() => {
    if (isError) {
      queryClient.invalidateQueries({ queryKey: ['isAuth'] })
    }
  }, [isError])

  const transformedFilters: IFilters | undefined = useMemo(() => {
    const employmetsArray = filters?.employments?.split(';')
    return filters ? {
      ...filters,
      employments: EMPLOYMENTS.filter(emp => employmetsArray?.includes(emp.value)),
      experience: EXPERIENCES.find(exp => exp.value === filters?.experience),
      city: {value: filters?.city || '', label: filters?.city || 'Все'},
      keyWords: filters.keyWords?.length ? filters.keyWords?.split(';') : [],
      companies: filters.companies?.length ? filters.companies?.split(';') : [],
      sources: filters.sources?.length ? filters.sources.split(';') : [],
      filterByCompanies: filters.filterByCompanies || false
    } : undefined
  }, [filters]) 

  return {data: transformedFilters, isError, ...args}
}